import ConfirmView from "./confirm";
import SuccessView from "../../../common/success";
import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath, isPlainObject } from "../../../../../utils";

export default function view() {
  const $this = this;
  const { $charge, $inputs } = this;
  $this.CAN_SWITCH_TO_CONFIRM = false;

  return (view = ViewFactory({
    NAME: 'MPESA_INIT_VIEW',
    inputs: ['network', 'phone'],
    mutables: { timerCurrent: 'CURRENT_TIME' },
    constants: { hasBackAction: false },
    next() {
      const network = getValueAtPath($inputs, '[network].value');
      const phonenumber = getValueAtPath($inputs, '[phone].value');

      if (phonenumber && isPlainObject(network)) {
        $charge.init({
          data: { phonenumber, network: network.identifier },
          onBegin() {
            $this.mpesaOverrideTimeout && clearTimeout($this.mpesaOverrideTimeout);
            $this.mpesaOverrideTimeout = null;
            $this.mpesaPollingCompleted = false;
          },
          onRequireValidation() {
            $this.CAN_SWITCH_TO_CONFIRM = true;
          }
        });
      }
    }
  }).call(this));
}
